import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Toolbar, AppBar, Hidden } from '@material-ui/core'
import TitleBar from './title-bar/title-bar'

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: 'unset',
    backgroundColor: theme.palette.header.background,
    position: 'relative',
    width: `100%`,
    boxShadow: 'none',
  },
  appToolBar: {
    backgroundColor: theme.palette.header.background,
    marginLeft: '0px',
    padding: '0px 7px 0px 7px',
  },
}))

const Header = () => {
  const classes = useStyles()

  return (
    <>
      <Hidden smDown implementation='js'>
        <AppBar className={classes.appBar}>
          <Toolbar className={classes.appToolBar}>
            <TitleBar locale={localStorage.getItem('locale')} />
          </Toolbar>
        </AppBar>
      </Hidden>
    </>
  )
}

export default Header
